// Reconnection
export const RECONNECT_POLL_INTERVAL_MS = 3000;
export const DEVICE_SETUP_TIMEOUT_MS = 30000;

// File integrity
export const HASH_COMPUTATION_TIMEOUT_MS = 10000;
export const MAX_VERIFICATION_RETRIES = 3;
export const MAX_SYNC_CHECK_FILES = 50;
export const MAX_FILE_SIZE_BYTES = 1_048_576;

// Hash cache
export const FILE_HASH_CACHE_KEY = 'pyranger:fileHashCache';
